import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import UpdatePaymentMethodNotification from '../DebtPaymentComponents/updatePaymentMethodNotification';
import EmailNotification from '../DebtPaymentComponents/emailNotification';
import PaymentNotification from '../DebtPaymentComponents/paymentNotification';
import {successEnum, paymentType} from '../DebtPaymentComponents/debtPaymentEnum';
import {CSSTransition} from 'react-transition-group';
import '../debtPayment.scss';
import {report, getReportParams} from '../../../../middleware/report';
import TVNotification from '../DebtPaymentComponents/tvNotification';
import {gtag4} from '../../../../utilities/analytics/tracking';
import {dwhBitPaymentSuccess} from '../reports/dwhReports';

const DebtPaymentSuccessPrivate = (props) => {
  const [mount, setMount] = useState(false);
  const [allowToReport, setAllowToReport] = useState(false);

  useEffect(() => {
    if (props.currentStep === successEnum.PAYMENTSUCCESSPRIVATE) {
      setMount(true);
      if ((!isMobile && props.selectedPaymentType == paymentType.BIT) || props.selectedPaymentType == paymentType.CREDITCARD) {
        setAllowToReport(true);
      }
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  useEffect(() => {
    if (isMobile && props.bitReturnEvent) {
      setAllowToReport(true);
    }
  }, [props.bitReturnEvent]);

  useEffect(() => {
    if (allowToReport && mount) {
      const selectedAmount = `סכום לתשלום: ${props.privateAmount}`;
      const debtAmount = `סה"כ יתרה: ${props.savedCustomerData.amount}`;
      const source = props.isJetConnection ? 'JET' : 'WEBSITE';
      const customerName = props.savedCustomerData.name;
      const ban = props.selectedBan;
      const idNumber = props.idNumber;
      const subscriber = props.phoneNumber;
      if (props.selectedPaymentType == paymentType.BIT) {
        //GA
        gtag4({
          event: 'DebtPayment_Step3_BitSuccessPage',
          step: '3',
          action: 'BitSuccessPage',
        });
        //DWH
        dwhBitPaymentSuccess({debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber});
      } else {
        // GA
        gtag4({
          event: 'DebtPayment_Step3_CcSuccessPage',
          step: '3',
          action: 'CcSuccessPage',
        });
        // DWH
        let paymentLeft = (parseFloat(props.debtAmount) - parseFloat(props.paymentData.amount)).toFixed(2);
        if (paymentLeft == null) {
          paymentLeft = '0.00₪';
        } else {
          paymentLeft += '₪';
        }
        let reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Private Debt Payment';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = 'Credit Card Payment Details Page';
        reportParams.status = 'Completed';
        reportParams.banId = props.savedCustomerData?.number;
        reportParams.idNumber = props.savedCustomerData?.idNumber;
        reportParams.messageText = 'Success';
        reportParams.subscriber = props.phoneNumber;
        reportParams.param1 = 'סה"כ יתרה: ' + paymentLeft;
        reportParams.param2 = `סכום לתשלום: ${props.privateAmount}₪`;
        reportParams.customerName = props.savedCustomerData?.name;
        report(reportParams);

        if (props.noPaymentMethod) {
          reportParams = getReportParams();
          reportParams.area = 'SelfCare';
          reportParams.subArea = 'Private Debt Payment';
          reportParams.channel = 'WebsitePrivate';
          reportParams.actionType = 'Debt Success Page';
          reportParams.status = 'Ongoing';
          reportParams.banId = props.savedCustomerData?.number;
          reportParams.idNumber = props.savedCustomerData?.idNumber;
          reportParams.messageText = 'Payment Details Update Link Displayed';
          reportParams.subscriber = props.phoneNumber;
          report(reportParams);
        }
      }
      setAllowToReport(false);
    }
  }, [allowToReport, mount, props.currentStep]);

  const remainingPayment = (parseFloat(props.debtAmount) - parseFloat(props.paymentData.amount)).toFixed(2);

  const remainingPart = remainingPayment != null && remainingPayment != 0 && (
    <Row>
      <Col>
        <BasicText text={'יתרה לתשלום: ' + '₪' + remainingPayment} bold />
      </Col>
    </Row>
  );

  let blockedDeviceText = null;
  if (props.paused) {
    if (remainingPayment == 0) {
      if (props.noPaymentMethod) {
        blockedDeviceText = 'מכשירך ישאר בסטטוס הקיים עד הסדרת אמצעי התשלום';
      } else {
        blockedDeviceText = 'מכשירך יפתח לשימוש עד 3 שעות';
      }
    } else {
      blockedDeviceText = 'מכשירך ישאר בסטטוס הקיים עד להסדרת מלוא התשלום';
    }
  }
  const blockedPart = blockedDeviceText != null && (
    <Row>
      <Col>
        <BasicText text={blockedDeviceText} />
      </Col>
    </Row>
  );

  return (
    <CSSTransition key={8} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step privateSuccessScreenDebt'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='התשלום התקבל, תודה!' classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='justify-content-md-center'>
          <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
            <PaymentNotification
              authNumber={props.paymentData.receptionNo}
              amount={props.paymentData.amount}
              numOfPayments={props.paymentData.paymentNo}
            />
          </Col>
        </Row>
        {props.notifyTV && (
          <Row className='justify-content-md-center'>
            <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
              <TVNotification />
            </Col>
          </Row>
        )}
        {props.noPaymentMethod && (
          <Row className='justify-content-md-center'>
            <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
              <UpdatePaymentMethodNotification
                updatePaymentMethod={() => {
                  let paramsReport = getReportParams();
                  paramsReport.area = 'SelfCare';
                  paramsReport.subArea = 'Private Debt Payment';
                  paramsReport.channel = 'WebsitePrivate';
                  paramsReport.actionType = 'Debt Success Page';
                  paramsReport.status = 'Completed';
                  paramsReport.banId = props.savedCustomerData?.number;
                  paramsReport.idNumber = props.savedCustomerData?.idNumber;
                  paramsReport.messageText = 'Payment Details Update Link Clicked';
                  paramsReport.subscriber = props.phoneNumber;
                  report(paramsReport);
                  props.updatePaymentMethod();
                }}
                isPrivate={true}
              />
            </Col>
          </Row>
        )}
        {props.email && (
          <Row className='justify-content-md-center'>
            <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
              <EmailNotification email={props.email} />
            </Col>
          </Row>
        )}
        {(blockedPart || remainingPart) && (
          <Row className='justify-content-md-center'>
            <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
              <Container className='debtpayment-notification-container'>
                {remainingPart}
                {blockedPart}
              </Container>
            </Col>
          </Row>
        )}
        <Row className='justify-content-md-center footer-btn privateSuccessFooterBtn'>
          <Col md='auto'>
            <BtnSubmit formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentSuccessPrivate;
